qw-textarea {
  display: flex;
}

qw-textarea textarea {
  min-height: 200px;
}
